import Component from "../classes/Component"
import { app, menu, navigation, search } from '../utils/store'

export default class Search extends Component {
    constructor(){
        super({
            element: '#search',
            elements: {
                form: 'form',
                input: 'input[type="text"]',
                submit: 'button[type="submit"]'
            }
        })
    }
    
    create(){
        super.create()
        
        app.search = this.element
        
        this.elements.input.onfocus = (event) => { this.onFocus(event) }
        this.elements.input.onblur = (event) => { this.onBlur(event) }
        
        if(app.device.mobile){
            this.elements.form.onclick = (event) => { this.onClick(event) }
        }
    }
    
    addEventListeners(){

    }

    onClick = (event) => {
        if(this.elements.submit && navigation.isOpen && menu.isOpen){
            if(!search.isActive){
                app.html.classList.add('scroll--off')
                app.root.classList.add('search--active')
                this.elements.input.focus()
            }
        }
    }

    onFocus = (event) => {
        app.root.classList.add('search--active')
    }

    onBlur = (event) => {
        this.elements.input.value = ''
        app.root.classList.remove('search--active')
    }

    destroy = () => { /** Code your own */ }
}